import React, { useEffect, useRef, useState } from "react";
import { Icon } from "@iconify/react";
import {
  Button,
  PinInput,
  PinInputField,
  useDisclosure,
  Text,
  useToast,
} from "@chakra-ui/react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
} from "@chakra-ui/react";

const ShowBrandButton = ({ isViewBrand, setIsViewBrand }) => {
  const [pin, setPin] = useState("");
  const [error, setError] = useState("");
  const toast = useToast();
  const firstPinRef = useRef(null);

  const handlePinSubmit = (value) => {
    const enteredPin = value ?? pin;
    if (enteredPin === "123123") {
      setIsViewBrand((prev) => ({
        ...prev,
        authorized: true,
        popup: false,
      }));
      setPin("");
      setError("");
      toast({
        title: "Showing more info...",
        status: "success",
        duration: 2000,
        isClosable: true,
        position: "top",
      });
    } else {
      setError("Wrong pin");
    }
  };

  const handlePinChange = (value) => {
    setPin(value);
    setError("");
    if (value.length === 6) {
      handlePinSubmit(value);
    }
  };

  const handleModalClose = () => {
    setIsViewBrand((prev) => ({
      ...prev,
      popup: false,
    }));
    setPin("");
    setError("");
  };

  useEffect(() => {
    isViewBrand.popup && firstPinRef.current?.focus();
  }, [isViewBrand.popup]);

  return (
    <div>
      {" "}
      <Button
        onClick={() => {
          if (isViewBrand.authorized) {
            setIsViewBrand((prev) => ({
              ...prev,
              authorized: !prev.authorized,
            }));
          } else {
            setIsViewBrand((prev) => ({
              ...prev,
              popup: !prev.authorized,
            }));
          }
        }}
        size={"xs"}
        colorScheme="teal"
        display={"flex "}
        alignItems={"center"}
        gap={2}
      >
        {isViewBrand.authorized ? "Hide" : "View"} More Info
        <Icon
          width={16}
          icon={
            isViewBrand.authorized
              ? "fluent:eye-off-20-regular"
              : "fluent:eye-20-regular"
          }
        />
      </Button>
      <Modal
        isOpen={isViewBrand.popup}
        onClose={handleModalClose}
        initialFocusRef={firstPinRef}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Enter Pin </ModalHeader>
          <ModalCloseButton />
          <ModalBody w={"100%"}>
            <div className=" w-full flex  items-center justify-center gap-3">
              <PinInput value={pin} onChange={handlePinChange} otp>
                <PinInputField ref={firstPinRef} autoFocus />
                <PinInputField />
                <PinInputField />
                <PinInputField />
                <PinInputField />
                <PinInputField />
              </PinInput>
            </div>
            {error && (
              <Text color="red.500" fontSize="sm">
                {error}
              </Text>
            )}
          </ModalBody>

          <ModalFooter />
        </ModalContent>
      </Modal>
    </div>
  );
};

export default ShowBrandButton;
